import {OutUnit} from './OutUnit';

export const OutUnitMap: Map<number, string> = new Map<number, string>([
	[OutUnit.Kelvin, 'K'],
	[OutUnit.DegCelsius, '°C'],
	[OutUnit.DegFahrenheit, '°F'],
	[OutUnit.RelHumidity, '%'],
]);
